import type * as React from "react";
import { mq } from "../responsive/breakpoints";
import { type FontFace, mkFontStack, notoRegular } from "./font-faces";

export interface FontProps {
  name: string;
  fontFace: FontFace;
  cssProperties: React.CSSProperties;
}

const mkFont = (fontProps: FontProps, cssProperties?: $FixMe) => {
  const style = mq({
    fontFamily: mkFontStack(fontProps.fontFace),
    ...fontProps.fontFace.cssProperties,
    ...fontProps.cssProperties,
    ...cssProperties,
  });

  style.fontProps = fontProps;

  return style;
};

/**
 *  [xs, s, m, l]
 */

export const fontTable = mkFont(
  {
    name: "Table",
    fontFace: notoRegular,
    cssProperties: {
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  {
    fontSize: ["12px", "12px", "14px", "14px"],
    lineHeight: ["16px", "16px", "20px", "20px"],
  },
);

const fontMeta = mkFont(
  {
    name: "Meta",
    fontFace: notoRegular,
    cssProperties: {
      fontSize: "12px",
      lineHeight: "16px",
    },
  },
  {
    fontSize: ["10px ", "10px ", "12px ", "12px "],
    lineHeight: ["14px", "14px", "16px", "16px"],
  },
);

const fontAxis = mkFont(
  {
    name: "Axis",
    fontFace: notoRegular,
    cssProperties: {
      fontSize: "10px",
      lineHeight: "14px",
    },
  },
  {
    fontSize: ["10px ", "10px ", "10px ", "10px "],
    lineHeight: ["14px", "14px", "14px", "14px"],
  },
);

// Aliased typefaces for charts

export const fontAxisLabel = fontAxis;
export const fontChartLabel = fontMeta;
